// Encrypts the data using AES and then encrypts the AES key using RSA with a public key code.

const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAkQmi05aI4PA+T5Jw95Pp
/za8uUnkFa+eutalURMCVja39rr8D7rukMgY3pFhaD3OFLYia9CFF/S9Kk/v4uyn
stx4ghb+Yo2VpHSnLCL+D6A/2QKf8YrjA3i+czsZdWuQ87lR/VRk8n3ygjvwfHek
qcLJq6ZcuitG9pN4L7o5HV/HT1Qo3BzMD4R8adg4WVdoZcBOFh4VBCfCtH7jFgsO
x9VUXF1dGnV/udDtvzDpxZLxkG1ZExnC2/WwTA+I/cT0vNLiWa6/zPyeKqkVtzaa
b6k4J4jRpvXkyKxZiRGDTidWUlbZpeUO6Ci5dXWtlE/xin2EMNncYL+giZ8IxM05
4NtDVLXShO6xRSaZ6y6HkiFYMBqkQwgNuJ6Sk9u3/hR7T+DZJ3O4ZqdhxPca2VgE
DmHPwJz1wiMRQa8YJ304C3q0+ndIdUVcqh0CggyU8E12Iy9D1eN2zZlPVuyoeHpm
qisXvMotZil5qUoRWBtsdeTnK/tCiOjQVbMVvBQzqoZ/LUdxzAaaqbV7/7UzD+9O
vemCtOkdSTGLPa+kjGt8bMod5CDHA4it0KW5GcoFKFklqCSDCfb7AlfESaS+WPWq
rvMNSTimfJ1vXPvJz5AdvNLypvshPbvl4RbwFwQ4+SR7S3epV3XS3knuDEm+Xyqp
rKPk6w+A3QCD+r25CrNF9uUCAwEAAQ==
-----END PUBLIC KEY-----
`;

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return window.btoa(binary);
};

const generateAESKey = async () => {
  return await window.crypto.subtle.generateKey({ name: "AES-CBC", length: 256 }, true, ["encrypt", "decrypt"]);
};

const encryptAES = async (data, aesKey) => {
  const iv = window.crypto.getRandomValues(new Uint8Array(16));
  const encodedData = new TextEncoder().encode(JSON.stringify(data));
  const encryptedBuffer = await window.crypto.subtle.encrypt({ name: "AES-CBC", iv }, aesKey, encodedData);
  return {
    encryptedData: arrayBufferToBase64(encryptedBuffer),
    iv: arrayBufferToBase64(iv),
  };
};

const importPublicKey = async (pemKey) => {
  const binaryDerString = window.atob(pemKey.replace(/-----.*?-----/g, "").replace(/\n/g, ""));
  const binaryDer = new Uint8Array(binaryDerString.length).map((char, i) => binaryDerString.charCodeAt(i));
  return await window.crypto.subtle.importKey("spki", binaryDer, { name: "RSA-OAEP", hash: "SHA-256" }, true, ["encrypt"]);
};

const encryptRSA = async (aesKey) => {
  const publicKey = await importPublicKey(PUBLIC_KEY);
  const exportedKey = await window.crypto.subtle.exportKey("raw", aesKey);
  const encryptedBuffer = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, publicKey, exportedKey);
  return arrayBufferToBase64(encryptedBuffer);
};